import { render, staticRenderFns } from "./TransportBox.vue?vue&type=template&id=8422b456&lang=pug"
import script from "./TransportBox.vue?vue&type=script&lang=js"
export * from "./TransportBox.vue?vue&type=script&lang=js"
import style0 from "./TransportBox.vue?vue&type=style&index=0&id=8422b456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports